import { AxiosInstance } from 'axios'
import { useMutation, useQueryClient } from 'react-query'

import { useSvcCrunchesContext } from '@dc-shared-web/providers'

import { Assignment } from '@dc-shared-web/hooks/api/assignment/types'

type DeleteAssignmentParams = {
  assignment_uuid: string
  checklist_data_uuid: string
  crunch_uuid: string
}

const deleteAssignment = async (
  apiClient: AxiosInstance,
  { assignment_uuid }: DeleteAssignmentParams
): Promise<Assignment> => {
  const { data } = await apiClient.delete<Assignment>(
    `/api/assignments/${assignment_uuid}`
  )

  return data
}

export const useDeleteAssignment = () => {
  const apiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()

  return useMutation<Assignment, unknown, DeleteAssignmentParams, unknown>(
    (mutationParams: DeleteAssignmentParams) =>
      deleteAssignment(apiClient, mutationParams),
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries([
          'assignments',
          variables.checklist_data_uuid,
          variables.crunch_uuid,
        ])
      },
    }
  )
}
